import { Drawer, DrawerProps } from 'antd';
import { ReactNode } from 'react';

interface Props extends DrawerProps {
    children?: ReactNode;
}

function EnhancedDrawer({ children, ...props }: Props) {
    return (
        <Drawer {...props} className={props.className ? 'rl-drawer ' + props.className : 'rl-drawer'}>
            {children}
        </Drawer>
    );
}

export default EnhancedDrawer;
